<div
  [@drawerStatus]="status"
  class="d-flex flex-column ms-3"
  [ngClass]="
    chatRoom?.status === 'Opened' ? 'chat-drawer' : 'chat-drawer-collapsed'
  "
>
  <div
    [id]="'drawer-header'"
    class="d-flex flex-row mx-3 justify-content-between align-items-center header"
    (click)="toggleCollapseChat(chatRoom)"
  >
    <div class="d-flex flex-row align-items-center">
      <em
        class="fas icon"
        [ngClass]="source === 'Retailer' ? 'fa-dolly' : 'fa-shopping-basket'"
        aria-hidden="true"
      ></em>
      <div class="d-flex flex-column m-0 ms-2">
        <h6 class="drawer-header-text mb-0">
          {{
            !!messagesToRender?.length || chatRoom?.loading
              ? source === "Retailer"
                ? chatRoom?.supplierName
                : chatRoom?.customerName
              : "New Message"
          }}
        </h6>
        @if (source === "Supplier") {
          <div class="supplier-info font-size-9">
            {{ chatRoom?.supplierName }} | ESN {{ chatRoom?.supplierNumber }}
          </div>
        }
      </div>
    </div>
    @if (
      chatRoom?.clientNumberUnread === chatRoom?.supplierNumber &&
      chatRoom?.status === "Collapsed"
    ) {
      <em class="unread-icon"></em>
    }
    <em
      class="far fa-times"
      title="Close"
      (click)="closeChatRoom($event, chatRoom.id)"
    ></em>
  </div>
  @if (chatRoom?.status === "Opened") {
    <div class="panel-divider"></div>
  }
  @if (chatRoom?.status === "Opened") {
    <div
      [id]="'drawer-body'"
      class="body mx-3"
      #scrollToBottom
      (scroll)="onScroll($event)"
    >
      @if (!messagesToRender?.length) {
        <div
          class="d-flex h-100 align-items-center flex-column justify-content-center"
        >
          @if (!chatRoom?.loading) {
            <div
              [id]="'drawer-no-messages'"
              class="d-flex h-100 align-items-center flex-column justify-content-center"
            >
              <em
                class="fas"
                [ngClass]="
                  source === 'Retailer' ? 'fa-dolly' : 'fa-shopping-basket'
                "
                aria-hidden="true"
              ></em>
              <h6 class="my-2">{{ chatRoom?.customerName }}</h6>
              <div class="detail">Start a message with this retailer.</div>
            </div>
          }
          @if (chatRoom?.loading) {
            <div [id]="'drawer-loading-messages'">
              <kehe-phoenix-loading></kehe-phoenix-loading>
            </div>
          }
        </div>
      }
      @if (messagesToRender?.length) {
        <div>
          @if (chatRoom.loadingMoreMessages) {
            <div class="my-3">
              <kehe-phoenix-loading></kehe-phoenix-loading>
            </div>
          }
          @for (messageToRender of messagesToRender; track messageToRender) {
            <div class="d-flex flex-column">
              <div
                [id]="'message-to-render-date-' + messagesToRender?.date"
                class="dateToRender mt-2"
              >
                {{ messageToRender?.date }}
              </div>
              @for (message of messageToRender?.messages; track message) {
                <div [id]="'message-' + message?.id">
                  <app-chat-bubble [message]="message"></app-chat-bubble>
                </div>
              }
            </div>
          }
          <div class="mb-3"></div>
        </div>
      }
    </div>
  }
  @if (chatRoom?.status === "Opened") {
    <div [id]="'drawer-footer'" class="footer">
      <form [formGroup]="inputForm" class="mx-3 d-flex h-100 align-items-end">
        <kendo-textarea
          class="text-input"
          resizable="auto"
          placeholder="Start message"
          formControlName="textMessage"
          (keyup.enter)="submit()"
          (blur)="onBlurMethod()"
          [maxlength]="MAX_TEXT_MESSAGE_LENGTH"
        >
        </kendo-textarea>
        <div
          class="send-button d-flex justify-content-center align-items-center"
          [ngClass]="
            inputForm?.controls?.textMessage?.value?.length > 0
              ? 'send-button-enabled'
              : 'send-button-disabled'
          "
          (click)="submit()"
        >
          <em class="fas fa-arrow-up"></em>
        </div>
      </form>
    </div>
  }
</div>
